module.exports = __webpack_public_path__ + "media/images/version_merge/why_us_background_block-176bd6964606189723fe7305419b5d06.svg";